import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';
import { BreadcrumbBar } from './BreadcrumbBar';
import { BreadcrumbLeafProvider } from './breadcrumbContext';
import { LAYOUT } from '../theme/layout';

export function AppLayout() {
  return (
    <BreadcrumbLeafProvider>
      <Box sx={{ display: 'flex', bgcolor: 'background.default', minHeight: '100vh' }}>
        <Topbar />
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            px: LAYOUT.pagePaddingX,
            py: LAYOUT.pagePaddingY,
          }}
        >
          <Toolbar />
          <Box sx={{ maxWidth: LAYOUT.contentMaxWidth, mx: 'auto' }}>
            <BreadcrumbBar />
            <Outlet />
          </Box>
        </Box>
      </Box>
    </BreadcrumbLeafProvider>
  );
}
